import z from 'zod';
import { CurrencyConfig } from '../finance/currency-schema';
import { AuditSchema } from '../settings/audit-schema';
import { PublicSchema } from '../settings/public-schema';
import { SubscriptionSchema } from '../finance/subscription-schema';
import type { Business, BusinessWithId } from './business-schema';

export const DashboardModeSchema = z.enum(['normal', 'course']);
export type DashboardMode = z.infer<typeof DashboardModeSchema>;

export const Base = z.object({
  email: z.string(),
  account_type: z.literal('business'),
  dashboardMode: DashboardModeSchema.default('normal'),
  subscription: SubscriptionSchema.default({
    plan: 'SOLO',
    isFounder: false,
    expiresAt: null,
    updatedAt: null,
  }),
  public: PublicSchema,
  audit: AuditSchema,
  currencyConfig: CurrencyConfig,
});

export type Owner = Business;
export type OwnerWithId = BusinessWithId;
export type OwnerType = 'business';

export function fieldToFilter(ownerType: OwnerType) {
  return 'businessId';
}
